export default "__VITE_ASSET__BAyeiNTw__"